import { FC, ComponentType } from 'react';
import { HeadProvider } from 'react-head';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { History } from 'history';
import { Store } from 'redux';

import { AppRoutes, PageErrorState } from '../../types';
import Page from './Page';

interface AppProps {
    store: Store;
    history: History;
    proxyComponent?: ComponentType;
    routes: AppRoutes;
    pageWrapper?: ComponentType;
    errorComponent?: ComponentType<PageErrorState>;
    place?: string;
}

const App: FC<AppProps> = ({ store, history, routes, proxyComponent, pageWrapper, errorComponent, place }) => {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <HeadProvider>
                    <Page
                        place={place}
                        routes={routes}
                        proxyComponent={proxyComponent}
                        pageWrapper={pageWrapper}
                        errorComponent={errorComponent}
                    />
                </HeadProvider>
            </ConnectedRouter>
        </Provider>
    );
};

export default App;
